/* Blogcikk: olvasási sáv, tartalomjegyzék, Kosárba a „Mézek a cikkből"
   dobozban. A 2026-09-11-i terv szerint (design-blog-2026-09-11/).

   A görgetés-esemény csak CÉLÉRTÉKET állít, a kitöltést egy
   requestAnimationFrame-hurok simítja oda (2026-09-12). MÉRÉSNÉL viszont
   figyelni kell: a rAF háttérben lévő lapon nem fut, ezért ott a sáv
   állása nem frissül (ld. „Hibakereso - visszatero hibamintak.md", D). */
(function () {
  'use strict';

  var cikk = document.querySelector('.pm-cikk');
  if (!cikk) return;

  var torzs = cikk.querySelector('.pm-cikk__torzs');
  var sav = document.querySelector('.pm-cikk-sav');
  var tolto = sav ? sav.querySelector('.pm-cikk-sav__tolto') : null;

  /* A fejléc alja: a sáv közvetlenül alatta ül, a ragadós oldalsáv ehhez
     igazodik. Ha a fejléc görgetéskor elrejtőzik, ez 0 lesz. Az első
     NEM nulla méretű jelöltet vesszük — egy `display: contents` elem
     0×0-t mérne (Hibakereső, D). */
  var fejlecJeloltek = ['header-component', '#header-group .header', '.header-section', 'header'];
  function fejlecAlja() {
    for (var i = 0; i < fejlecJeloltek.length; i++) {
      var h = document.querySelector(fejlecJeloltek[i]);
      if (!h) continue;
      var r = h.getBoundingClientRect();
      if (r.height > 0) return Math.max(0, Math.round(r.bottom));
    }
    return 0;
  }

  /* 2026-09-12 — a sáv desktopon szakadozott. Két oka volt, és mindkettő
     minden egyes görgetés-eseménynél lefutott:
       1. újramértük a fejléc alját és a szövegtörzs alját (getBoundingClientRect),
          majd írtunk is egy CSS-változót — vagyis olvasás-írás-olvasás
          kényszerített újratördelést, görgetésenként;
       2. a kitöltésen CSS-átmenet ült, amit minden új érték újraindított,
          így az animáció folyton önmagát üldözte.
     Most: a MÉRÉS csak betöltéskor, átméretezéskor és a fejléc animációja után
     fut; a görgetés csak egy célértéket állít; a mozgást képkockánként egy
     requestAnimationFrame-hurok simítja (a CSS-átmenet a kitöltésről lekerült). */
  var fejlecMost = -1;
  var vegPont = 0;
  var cel = 0;
  var allas = 0;
  var futHurok = false;
  var haladt = false;

  function meretFrissit() {
    /* A fejléc alja csak a ragadós oldalsáv eltolásához kell (CSS-változó).
       A SÁV NEM követi: a képernyő tetején ül, és akkor úszik be, amikor a
       fejléc már elgörgött. Korábban a sáv a fejléc alá volt igazítva, és
       görgetéskor láthatóan lemaradt mögötte. */
    var fa = fejlecAlja();
    if (fa !== fejlecMost) {
      fejlecMost = fa;
      document.documentElement.style.setProperty('--pm-cikk-fejlec', fa + 'px');
    }
    if (torzs) {
      var alja = torzs.getBoundingClientRect().bottom + window.scrollY;
      vegPont = alja - window.innerHeight;
    }
    celFrissit();
  }

  function celFrissit() {
    cel = vegPont > 0 ? window.scrollY / vegPont : 1;
    cel = Math.min(1, Math.max(0, cel));
    /* Akkor látszik, amikor a fejléc alja már kigörgött a képből, ÉS amíg a
       cikk szövege tart. A szöveg vége után (termékek, hírlevél, hozzászólások,
       kapcsolódó cikkek) elhalványul: mobilon ezek a szöveg ALÁ kerülnek, így a
       sáv a görgetés 26%-ánál teleszaladt, és háromnegyed oldalon át teli
       maradt. A 80px ráhagyás azért kell, hogy a teli sáv egy pillanatra
       látszódjon, mielőtt eltűnik. */
    var hatar = fejlecMost > 8 ? fejlecMost - 8 : 2;
    var most = window.scrollY > hatar && window.scrollY < vegPont + 80;
    if (sav && most !== haladt) {
      haladt = most;
      sav.classList.toggle('is-halad', most);
    }
    if (!futHurok) {
      futHurok = true;
      requestAnimationFrame(lepes);
    }
  }

  function lepes() {
    var kulonbseg = cel - allas;
    if (Math.abs(kulonbseg) < 0.0015) {
      allas = cel;
      futHurok = false;
    } else {
      allas += kulonbseg * 0.22;
      requestAnimationFrame(lepes);
    }
    if (tolto) tolto.style.transform = 'scaleX(' + allas + ')';
  }

  window.addEventListener('scroll', celFrissit, { passive: true });
  window.addEventListener('resize', meretFrissit);
  window.addEventListener('load', meretFrissit);
  /* A fejléc elrejtése/visszajövetele animált: a végén még egyszer igazítunk. */
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.closest && e.target.closest('header-component, .header-section, #header-group')) meretFrissit();
  }, true);
  /* A cikk magassága utólag is változhat (képek, beágyazott blokkok). */
  if (window.ResizeObserver && torzs) {
    new ResizeObserver(meretFrissit).observe(document.body);
  }
  meretFrissit();

  /* Tartalomjegyzék a cikk köztes címeiből (h2). Két helyre kerül: desktopon
     az oldalsávba, mobilon a cikk elejére, összecsukható dobozba. Két címnél
     kevesebbnél nincs értelme, olyankor rejtve marad. */
  var cimek = torzs ? [].slice.call(torzs.querySelectorAll('h2')) : [];
  var tocok = [].slice.call(cikk.querySelectorAll('[data-pm-toc]'));

  if (cimek.length >= 2 && tocok.length) {
    cimek.forEach(function (h, i) {
      if (!h.id) h.id = 'resz-' + (i + 1);
    });

    tocok.forEach(function (doboz) {
      var lista = doboz.querySelector('[data-pm-toc-lista]');
      cimek.forEach(function (h, i) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.className = 'pm-cikk-toc__elem';
        var szam = document.createElement('span');
        szam.className = 'pm-cikk-toc__szam';
        szam.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        var szoveg = document.createElement('span');
        szoveg.textContent = h.textContent.trim();
        a.appendChild(szam);
        a.appendChild(szoveg);
        lista.appendChild(a);
      });
      var db = doboz.querySelector('[data-pm-toc-db]');
      if (db) db.textContent = cimek.length + ' rész';
      doboz.hidden = false;

      /* Mobilon a doboz a választás után összecsukódik. */
      if (doboz.tagName === 'DETAILS') {
        lista.addEventListener('click', function (e) {
          if (e.target.closest('a')) doboz.open = false;
        });
      }
    });

    var aktivFrissit = function () {
      var hatar = fejlecAlja() + 48;
      var aktiv = 0;
      cimek.forEach(function (h, i) {
        if (h.getBoundingClientRect().top - hatar <= 0) aktiv = i;
      });
      tocok.forEach(function (doboz) {
        [].forEach.call(doboz.querySelectorAll('.pm-cikk-toc__elem'), function (a, i) {
          a.classList.toggle('is-aktiv', i === aktiv);
        });
      });
    };
    window.addEventListener('scroll', aktivFrissit, { passive: true });
    aktivFrissit();
  }

  /* Kosárba a „Mézek a cikkből" dobozban — ugyanaz a folyamat, mint a
     kosár-ajánló gombjain (assets/pm-cart-cross-sell.js): /cart/add.js,
     majd cart:update a friss kosárral — erre nyílik a natív drawer, és
     erre reagál a mobil kosársáv (assets/pm-cart-toast.js). */
  cikk.addEventListener('click', function (e) {
    var gomb = e.target.closest ? e.target.closest('.pm-cikk-termek__gomb') : null;
    if (!gomb) return;
    e.preventDefault();
    var id = parseInt(gomb.getAttribute('data-variant-id'), 10);
    if (!id || gomb.disabled) return;
    var eredeti = gomb.textContent;
    gomb.disabled = true;
    gomb.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('kosar');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (kosar) {
        document.querySelectorAll('cart-count').forEach(function (el) {
          el.textContent = kosar.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: kosar, sourceId: 'pm-cikk', data: {} }
        }));
        gomb.textContent = 'Kosárban ✓';
        setTimeout(function () {
          gomb.textContent = eredeti;
          gomb.disabled = false;
        }, 2000);
      })
      .catch(function () {
        gomb.textContent = 'Hiba — próbáld újra';
        setTimeout(function () {
          gomb.textContent = eredeti;
          gomb.disabled = false;
        }, 2500);
      });
  });
})();
